export default __webpack_public_path__ + "static/media/right-arrow-dark.35c610eb.svg";